/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type UserPopoverOverviewContainer_user = {
    readonly id: string;
    readonly username: string | null;
    readonly createdAt: string;
    readonly ignoreable: boolean;
    readonly bio: string | null;
    readonly " $refType": "UserPopoverOverviewContainer_user";
};
export type UserPopoverOverviewContainer_user$data = UserPopoverOverviewContainer_user;
export type UserPopoverOverviewContainer_user$key = {
    readonly " $data"?: UserPopoverOverviewContainer_user$data;
    readonly " $fragmentRefs": FragmentRefs<"UserPopoverOverviewContainer_user">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserPopoverOverviewContainer_user",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "username",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ignoreable",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bio",
            "storageKey": null
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '18c68a756a3614e025d566fb6b8b6e6f';
export default node;
